export default {
    validate: value => {

        const isValid = value.match(new RegExp("^[A-Za-z.\\- ]+$"));

        if (!isValid) { return `Valid characters are A-Z, a-z, periods, hyphens, and spaces.` };

        return true;

    }
};
